import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const applicantsGet = (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.includeInactivePostings !== undefined) {
        params.append('includeInactivePostings', filters.includeInactivePostings);
    }
    if (filters.startDate) {
        params.append('startDate', filters.startDate);
    }
    if (filters.endDate) {
        params.append('endDate', filters.endDate);
    }
    if (filters.assignedToId) {
        params.append('assignedToId', filters.assignedToId);
    }
    if (filters.jobPostingId) {
        params.append('jobPostingId', filters.jobPostingId);
    }
    if (filters.cityId) {
        params.append('cityId', filters.cityId);
    }
    if (filters.provinceId) {
        params.append('provinceId', filters.provinceId);
    }
    
    const queryString = params.toString();
    return axios.get(`${apiUrl}ats/applicants${queryString ? `?${queryString}` : ''}`);
};

export const applicantGetById = (id) =>
    axios.get(`${apiUrl}ats/applicants/${id}`);

export const applicantCreate = (data) =>
    axios.post(`${apiUrl}ats/applicants`, data);

export const applicantCreateWithFile = (formData) =>
    axios.post(`${apiUrl}ats/applicants`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

export const applicantUpdate = (id, data) =>
    axios.put(`${apiUrl}ats/applicants/${id}`, data);

export const applicantDelete = (id) =>
    axios.delete(`${apiUrl}ats/applicants/${id}`);

export const applicantReprocess = (id) =>
    axios.post(`${apiUrl}ats/applicants/${id}/reprocess`, {});
